import { Component } from "@angular/core";

@Component({
    selector: "app-titulos-loading-snack-bar",
    templateUrl: "./titulos-loading-snack-bar.component.html",
    styleUrls: ["./titulos-loading-snack-bar.component.scss"],
})
export class TitulosLoadingSnackBarComponent {}
